<template>
  <div>
    <div class="col-md-12">
      <div class="my-4 col-md-12">
        <b-button @click="insertTemplate">Add Template</b-button>
      </div>
      <div>
        <b-table
          :busy="loading"
          responsive
          striped
          hover
          :fields="fields"
          :items="templates"
        >
        <template #cell(Action)="data">
          <b-icon style="cursor:pointer" v-b-tooltip.hover="'Edit'" icon="pencil" @click="edit(data.item)"></b-icon>
          <b-icon style="cursor:pointer" v-b-tooltip.hover="'Delete'" class="ml-2" icon="trash" @click="deleteTemplate(data.item.flow)"></b-icon>
        </template>
        <template #table-busy>
          <div class="text-center text-danger my-5">
            <b-spinner class="align-middle"></b-spinner>
            <p class="my-3"><strong>We are Loading...</strong></p>
          </div>
        </template>
        </b-table>
      </div>
    </div>
    <div class="col-md-12">
      <div>
        <b-modal
          ref="saveData"
          size="md"
          id="modal-center"
          scrollable
          centered
          title="Add/Edit Template"
          hide-footer
        >
          <div>
            <b-form @submit="onSubmit" v-if="show">
              <h5>Set Flow</h5>
              <b-form-group
                id="input-group"
                label="Funnel:"
                label-for="input"
              >
                <b-form-input
                  id="input"
                  v-model="form.funnel"
                  placeholder="Enter Funnel"
                  required
                ></b-form-input>
              </b-form-group>
              <b-form-group
                id="input-group-1"
                label="Flow Name"
                label-for="input-1"
                description="This will be display on top of the template card."
              >
                <b-form-input
                  id="input-1"
                  v-model="form.name"
                  type="text"
                  placeholder="Enter flow name"
                  required
                ></b-form-input>
              </b-form-group>

              <b-form-group
                id="input-group-2"
                label="Flow ID:"
                label-for="input-2"
              >
                <b-form-input
                  id="input-2"
                  v-model="form.flow"
                  placeholder="Enter flow ID"
                  required
                ></b-form-input>
              </b-form-group>
              <hr />
              <h5>Set DLT</h5>
              <b-form-group
                id="input-group-3"
                label="DLT Name:"
                label-for="input-3"
              >
                <b-form-input
                  id="input-3"
                  v-model="form.dlt.name"
                  placeholder="Enter DLT name"
                  required
                ></b-form-input>
              </b-form-group>

              <b-form-group
                id="input-group-4"
                label="DLT ID:"
                label-for="input-4"
              >
                <b-form-input
                  id="input-4"
                  v-model="form.dlt.id"
                  placeholder="Enter DLT ID"
                  required
                ></b-form-input>
              </b-form-group>
              <b-form-group
                id="input-group-5"
                label="Enter Template"
                label-for="input-5"
                description="The variables should be defined with identifier {#name#} eg. {#var#}"
              >
                <b-textarea
                  id="input-5"
                  v-model="form.template"
                  type="text"
                  placeholder="Enter template"
                  required
                ></b-textarea>
              </b-form-group>
              <hr />
              <h5>Set Variables</h5>
              <p>#VAR1</p>
              <b-form-group
                id="input-group-6"
                label="Variable Name:"
                label-for="input-6"
              >
                <b-form-input
                  id="input-6"
                  v-model="form.variables[0].name"
                  placeholder="Enter Variable Name"
                ></b-form-input>
              </b-form-group>
              <b-form-group
                id="input-group-7"
                label="Variable Text/ Field Description:"
                label-for="input-7"
              >
                <b-form-input
                  id="input-7"
                  v-model="form.variables[0].text"
                  placeholder="Enter Variable Name"
                ></b-form-input>
              </b-form-group>
              <hr />
              <p>#VAR2</p>
              <b-form-group
                id="input-group-8"
                label="Variable Name:"
                label-for="input-8"
              >
                <b-form-input
                  id="input-8"
                  :disabled="!form.variables[0].name"
                  v-model="form.variables[1].name"
                  placeholder="Enter Variable Name"
                ></b-form-input>
              </b-form-group>
              <b-form-group
                id="input-group-9"
                label="Variable Text/ Field Description:"
                label-for="input-9"
              >
                <b-form-input
                  :disabled="!form.variables[0].name"
                  id="input-9"
                  v-model="form.variables[1].text"
                  placeholder="Enter Variable Name"
                ></b-form-input>
              </b-form-group>

              <b-button type="submit" variant="primary">Submit</b-button>
            </b-form>
          </div>
        </b-modal>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      formMode: 'Insert',
      form: {
        name: "",
        flow: "",
        funnel: "",
        dlt: {
          name: "",
          id: "",
        },
        template: "",
        variables: [
          {
            position: 0,
            name: "",
            text: "",
            required: true,
          },
          {
            position: 1,
            name: "",
            text: "",
            required: true,
          },
        ],
      },
      fields: [
        {
          key: 'name',
        },
        {
          key: 'funnel'
        },
        {
          key: 'flow',
          label: 'Flow Id'
        },
        {
          key: 'dlt.name',
          label:'DLT Name'
        },
        {
          key: 'dlt.id',
          label:'DLT ID'
        },
        
        {
          key: 'variables',
          formatter : (item)=> {
            var x = ''
            item.forEach(data=>{
              x =  data.name  + ',' + x
            })
            return x
          }
        },
        {
          key: 'template',
          label:'Template'
        },
        {
          key: 'Action'
        }
      ],
      show: true,
      editId: ''
    };
  },
  created() {
    this.$store.dispatch("get_template_data", {});
  },
  computed: {
    loading() {
      return this.$store.state.loading_api
    },
    templates() {
      return this.$store.state.get_template_data || [];
    },
  },
  methods: {
    onSubmit(event) {
      event.preventDefault();
      // alert(JSON.stringify(this.form));
      if(this.formMode === 'Insert'){
        this.$store.dispatch("create_template", this.form).then(()=>{
          this.$refs["saveData"].hide();
          this.$store.dispatch("get_template_data", {});
          alert('done')
        })
      }else{
        this.form.id = this.editId
        this.$store.dispatch("edit_template", this.form).then(()=>{
          this.$refs["saveData"].hide();
          this.$store.dispatch("get_template_data", {});
          alert('done')
        })
      }    
    },
    deleteTemplate(id){
      if(confirm('Are you sure?')){
        this.$store.dispatch('delete_template', {id: id})
      }
    },
    insertTemplate(){
      this.formMode = 'Insert'
      this.$refs["saveData"].show();
    },
    edit(data){
      this.editId = data.flow
      this.form.name = data.name;
      this.form.flow = data.flow;
      this.form.template = data.template;
      this.form.dlt.name = data.dlt.name;
      this.form.dlt.id = data.dlt.id;
      this.form.funnel = data.funnel
      this.form.variables[0].name = data.variables[0].name;
      this.form.variables[0].text = data.variables[0].text;
      this.form.variables[1].name = data.variables[1].name;
      this.form.variables[1].text = data.variables[1].text;
      this.formMode = "Edit"
      this.$refs["saveData"].show();
    }
  },
};
</script>

<style></style>
